export const DAY_MILLISECONDS =
  1000 * // 1 s
  60 * // 1m
  60 * // 1h
  24; // 1d

export const DATE_NEW_PRIVATE_POLICY = '2024-05-15T08:00:00';
